module.exports = __webpack_public_path__ + "img/customsDeclaration.e185cb8.svg";